import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

// Tinted-badge pattern per KindBadge: transparent border + translucent bg + tinted text.
const DRAFT_STATUS_STYLES: Record<string, string> = {
  DRAFT: 'bg-zinc-400/15 text-zinc-400',
  SUBMITTED: 'bg-blue-400/15 text-blue-400',
  APPROVED: 'bg-emerald-400/15 text-emerald-400',
  REJECTED: 'bg-red-400/15 text-red-400',
};

/** Draft lifecycle chip: DRAFT gray / SUBMITTED blue / APPROVED green / REJECTED red. */
export function TfxStatusBadge({ status }: { status: string }) {
  const key = status.trim().toUpperCase();
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-transparent font-medium',
        DRAFT_STATUS_STYLES[key] ?? 'bg-zinc-400/15 text-zinc-400',
      )}
    >
      {key || '?'}
    </Badge>
  );
}

const JOB_STATUS_STYLES: Record<string, string> = {
  QUEUED: 'bg-zinc-400/15 text-zinc-400',
  RUNNING: 'bg-blue-400/15 text-blue-400',
  DONE: 'bg-emerald-400/15 text-emerald-400',
  FAILED: 'bg-red-400/15 text-red-400',
};

/** Render-job lifecycle chip: QUEUED gray / RUNNING blue / DONE green / FAILED red. */
export function TfxJobStatusBadge({ status }: { status: string }) {
  const key = status.trim().toUpperCase();
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-transparent font-medium',
        JOB_STATUS_STYLES[key] ?? 'bg-zinc-400/15 text-zinc-400',
      )}
    >
      {key || '?'}
    </Badge>
  );
}

/** Published-catalog chip: ACTIVE green / DELISTED red. */
export function TfxPublishedStatusBadge({ status }: { status: string }) {
  const key = status.trim().toUpperCase();
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-transparent font-medium',
        key === 'ACTIVE' ? 'bg-emerald-400/15 text-emerald-400' : 'bg-red-400/15 text-red-400',
      )}
    >
      {key || '?'}
    </Badge>
  );
}
